// extracted by mini-css-extract-plugin
export default {"main-block":"nnE58","main-block-load":"YnBNp","image":"gZWKI","image-wrapper":"qCXs8"};